import { PropsWithChildren, ReactNode } from 'react';

import { tokens, colorOrToken, Typography, Stack } from '@cast/design-system';
import type { TypographyProps } from '@cast/design-system';

type Props = PropsWithChildren<{
  label?: ReactNode;
  descriptionProps?: TypographyProps;
}>;

export const ControlWithDescription = ({
  label,
  descriptionProps = {},
  children,
}: Props) => {
  return (
    <Stack gap={4}>
      {label && <Typography variant="P14M">{label}</Typography>}
      <Typography
        variant="P12R"
        color={colorOrToken('grey.600', tokens.theme.fg.structural.secondary)}
        component="span"
        {...descriptionProps}
      >
        {children}
      </Typography>
    </Stack>
  );
};
